// extracted by css-extract-rspack-plugin
export default {"container":"_87c7c45"};